<template>
    <div class="view-body view-body--module">
      <div class="view-data">
        <div class="view-data__header view-data__header--module">
          <h1>{{title}}</h1>
        </div>
        <b-container fluid>
          <div class="table--wrapper">
            <b-table
              class="app-table legals-order-table module-table"
              show-empty
              stacked="md"
              :items="legals"
              :fields="fields"
              :busy="isBusy"
              hover>

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>

              <template slot="name" slot-scope="row">
                <div class="number-group">
                  {{row.item.name}}
                  <div @click="setActiveRow($event)" style="position:relative">
                    <div class="icon-mask" @click="row.toggleDetails"></div>
                    <svg class="arrow-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    width="100%" height="100%" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;"
                    xml:space="preserve">
                    <path fill="#000" d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
                      L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
                      c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/>
                    </svg>
                  </div>
                </div>
              </template>

              <template slot="pages" slot-scope="row">
                <span v-for="page in row.item.pages">
                  {{page}},
                </span>
              </template>

              <template slot="row-details" slot-scope="row">
                {{row.item.content}}
              </template>
              
              <template slot="empty">
                <p class="empty-message">Brak rekordów</p>
              </template>

            </b-table>
          </div>
        </b-container>
      </div>
  </div>

</template>

<script>

export default {

  name: 'legals',
  props:{

    orderId:{
      type: Number,
      default: 0
    },

  },
  data () {

    return {

      title: 'Lista zdań prawnych',

      isBusy: false,
      fields: [
        {
          key: 'name', 
          label: 'Nazwa' 
        },
        {
          key: 'pages', 
          label: 'Nr strony' 
        }
      ],

      legals: [],

    }

  },
  methods:{

    getLegals(){

      this.isBusy = true;
      const token = localStorage.getItem('auth_token');

      this.$http.get(`orders/${this.orderId}/legal/sentence`, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.legals = response.data.filter(o => o.code !== 0);
          this.isBusy = false;

        })
        .catch(error =>{

          console.error(error.response);
          this.loading = false;

        })

    },

    setActiveRow(event){

      let e = event.target.parentElement.querySelector('svg')
      
      if(e.classList.contains('active')){

        e.classList.remove('active');
        return;

      }
      
      e.classList.add('active');

    },

    saveLegals(){
      
      this.isBusy = true;
      this.saved = false;
      const token = localStorage.getItem('auth_token');
      let i = 0;
      let count = this.legals.length;

      this.legals.forEach( (legal) => {

        i++;

        let data = {
          name: legal.name,
        }

        this.$http.put(`legal-sentences/${legal.id}`, data, {
        headers: {
                
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

        }})
        .then(response => {

            if(i == count){

              this.isBusy = false;
              this.saved = true;
              this.getLegals();

            }

        })
        .catch(error => {

          console.error(error.response);

        })

      });

    },

  },
  mounted(){

    this.getLegals();

  }
};
</script>

<style lang="scss">



</style>
